import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/shop/ShopFAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/shop/ShopFeatures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/shop/ShopMethodsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/shop/ShopMethodsHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/shop/ShopVouchesModal.tsx");
